module.exports = __webpack_public_path__ + "img/servicenow.9c538c8c.svg";